import React, { Component } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import classnames from 'classnames';
import CikkcsoportLista from './CikkcsoportLista';
import CikktorzsContent from './CikktorzsContent';
import AfaLista from './AfaLista';
import CikkProfilContent from './CikkProfilContent';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from './CikkTooltips';

class CikkBase extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1',
      defaultRoles:
        [
          {
            rolename: 'CIKK_CSOPORT',
            tab: '1',
            spec: false
          },
          {
            rolename: 'CIKK_TORZS',
            tab: '2',
            spec: false
          },
          {
            rolename: 'CIKK_AFA',
            tab: '3',
            spec: false
          },
          {
            rolename: 'CIKK_PROFIL',
            tab: '4',
            spec: false
          },
        ],
    };
  }

  componentDidMount() {
    this.props.globals.setDefaultActiveTab(this.state.defaultRoles, this.toggle);
  }


  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render() {
    let cardStyle = {
      padding: 10
    };
    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              Cikk
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  {this.props.globals.hasRole(['CIKK_CSOPORT']) &&
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '1' })}
                        onClick={() => { this.toggle('1'); }}
                      >
                        Cikkcsoport
                        <CustomTooltip text={getTooltip('cikkcsoport')} id="cikkcsoportTT" />
                      </NavLink>
                    </NavItem>
                  }
                  {this.props.globals.hasRole(['CIKK_TORZS']) &&
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '2' })}
                        onClick={() => { this.toggle('2'); }}
                      >
                        Cikktörzs
                        <CustomTooltip text={getTooltip('cikktorzs')} id="cikktorzsTT" />
                      </NavLink>
                    </NavItem>
                  }
                  {this.props.globals.hasRole(['CIKK_AFA']) &&
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '3' })}
                        onClick={() => { this.toggle('3'); }}
                      >
                        Áfa
                        <CustomTooltip text={getTooltip('afa')} id="afaTT" />
                      </NavLink>
                    </NavItem>
                  }
                  {this.props.globals.hasRole(['CIKK_PROFIL']) &&
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '4' })}
                        onClick={() => { this.toggle('4'); }}
                      >
                        Cikk profil
                        <CustomTooltip text={getTooltip('cikkprofil')} id="cikkprofilTT" />
                      </NavLink>
                    </NavItem>
                  }
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  {this.props.globals.hasRole(['CIKK_CSOPORT']) &&
                    <TabPane tabId="1">
                      <CikkcsoportLista {...this.props} globals={this.props.globals} active={this.state.activeTab === '1'} />
                    </TabPane>
                  }
                  {this.props.globals.hasRole(['CIKK_TORZS']) &&
                    <TabPane tabId="2">
                      <CikktorzsContent {...this.props} globals={this.props.globals} active={this.state.activeTab === '2'} />
                    </TabPane>
                  }
                  {this.props.globals.hasRole(['CIKK_AFA']) &&
                    <TabPane tabId="3">
                      <AfaLista {...this.props} globals={this.props.globals} active={this.state.activeTab === '3'} />
                    </TabPane>
                  }
                  {this.props.globals.hasRole(['CIKK_PROFIL']) &&
                    <TabPane tabId="4">
                      <CikkProfilContent {...this.props} globals={this.props.globals} active={this.state.activeTab === '4'} />
                    </TabPane>
                  }
                </TabContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CikkBase;
